import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "../../GeneralDisclosure/TextFiledData";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import GRISidebar from "../../../../Layout/GRISidebar";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI201_2 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [fromData, setFromData] = useState({
    riskOrOpportunityDescription: "",
    descriptionOfImpact: "",
    financialImplications: "",
    methodsUsedToManage: "",
    costsOfActions: "",
  });
  const [griReview, setGriReview] = React.useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  React.useEffect(() => {
    const handleStorage = () =>
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    await get(`/gri/get?type=GRI200&Id=${id}`)
      .then((res) => {
        if (
          res?.data?.data?.year
            ? res?.data?.data?.year < currentYear - 1
            : false
        )
          setDisabled(true);
        const gri200data = res.data.data.GRI200;
        setFromData({
          riskOrOpportunityDescription:
            gri200data?.riskOrOpportunityDescription,
          descriptionOfImpact: gri200data?.descriptionOfImpact,
          financialImplications: gri200data?.financialImplications,
          methodsUsedToManage: gri200data?.methodsUsedToManage,
          costsOfActions: gri200data?.costsOfActions,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    Object.keys(fromData).forEach((key) => {
      const value = fromData[key];
      console.log(key, "checking keys value");
      if (typeof value === "object" && value !== null) {
        // If the value is an object, validate its fields
        Object.keys(value).forEach((subKey) => {
          if (!value[subKey]) {
            if (!newErrors[key]) newErrors[key] = {}; // Ensure section exists
            newErrors[key][subKey] = "This field is required";
          }
        });
      } else {
        // If the field is a simple string, validate directly
        if (!value) newErrors[key] = "This field is required";
      }
    });

    console.log(newErrors, "newErrors");
    setErrors(newErrors);
    return newErrors;
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    // const validationErrors = validateFields();

    // If there are errors, prevent form submission
    // if (Object.keys(validationErrors).length > 0) {
    //   console.log("Form contains errors", fromData, validationErrors);
    //   return;
    // }
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GRI200",
          ...fromData,
          submitted201_2: true,
        })
          .then((res) => {
            navigate(`/gri/economic-performance/201-3/${id}`);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/economic-performance/201-3/${id}`);
    }
  };

  const inputData = [
    {
      index: "a.",
      heading:
        "Risks and opportunities posed by climate change that have the potential to generate substantive changes in operations, revenue, or expenditure, including:",
      fields: [
        {
          index: "i.",
          subheading:
            "Description of the risk or opportunity and its classification as either physical, regulatory, or other;",
          fieldName: "riskOrOpportunityDescription",
        },
        {
          index: "ii.",
          subheading:
            "Description of the impact associated with the risk or opportunity;",
          fieldName: "descriptionOfImpact",
        },
        {
          index: "iii.",

          subheading:
            "The financial implications of the risk or opportunity before action is taken;",
          fieldName: "financialImplications",
        },
        {
          index: "iv.",
          subheading: "The methods used to manage the risk or opportunity;",
          fieldName: "methodsUsedToManage",
        },
        {
          index: "v.",
          subheading:
            "The costs of actions taken to manage the risk or opportunity.",
          fieldName: "costsOfActions",
        },
      ],
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>201:Economic Performance</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-3rem" : "0rem" }}
      >
        201-2: Financial implications and other risks and opportunities due to
        climate change
      </p>
      <TextFieldData
        // index={"201-2:"}
        // title=" Financial implications and other risks and opportunities due to climate change"
        {...{
          inputData,
          fromData,
          setFromData,
          disabled: disabled,
          setErrors,
          errors,
          hide,
        }}
      />
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI201_2;
